import React from "react";
import { store } from "@redux/store";
import actions from "@redux/EditableTable/actions";
import { Badge, Tooltip, Button, Avatar, Modal } from "antd";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import { api } from "@redux/api";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";

const renderDrawer = (text, id) => {
  store.dispatch(actions.OpenDrawer(true, id));
};
export const NotificationProps = {
  title: "Notification",
  description: "",
  name: "Notification",
};

export const NotificationColumns = () => [
  {
    title: "Key",
    dataIndex: "id",
    key: "id",
    editable: false,
    search: false,
    importIgnore: true,
    hideInTable: false,
    width: 60,
    sorter: (a, b) => a.id - b.id,
    render: (text, record) => {
      const { record_id, table } = record || {};

      if (record_id) {
        const state = store.getState();
        const facilityContext = getFacilityContext(state);
        const targetCompanyId = record?.company_id || facilityContext.companyId;
        const targetFacilityId = record?.facility_id || facilityContext.facilityId;
        const url = buildFacilityPath(table, {
          companyId: targetCompanyId,
          facilityId: targetFacilityId,
          query: { id: record_id },
        });

        if (!url) {
          return text;
        }

        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-link mr-2"></i>
            {record.record_id}
          </a>
        );
      }

      return text;
    },
  },
  {
    title: "Type",
    dataIndex: "type_of_notification",
    key: "type_of_notification",
    editable: false,
    search: true,
    importIgnore: false,
    hideInTable: false,
    width: 100,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 200,
    search: false,
    edit: true,
    hideInTable: false,
    sorter: (a, b) => a.description?.localeCompare(b.description),
    formItemProps: {
      rules: [
        {
          required: true,
          message: "required",
        },
      ],
    },
    render: (text, record, _, action) => (
      <Tooltip title={text}>
        {/* <a onClick={() => (action ? renderDrawer(text, record.id) : "")}> */}
          {text}
        {/* </a> */}
      </Tooltip>
    ),
    renderFormItem: () => <TextArea rows={1} />,
  },
  {
    title: "Sender",
    dataIndex: "sender_name",
    key: "sender_name",
    editable: false,
    search: true,
    importIgnore: false,
    hideInTable: false,
    width: 100,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    editable: false,
    search: false,
    importIgnore: false,
    hideInTable: false,
    width: 100,
    align: 'left', // 状态列左对齐
    render: (status) => (
      <Badge
        status={status === "unread" ? "error" : "success"}
        text={status.charAt(0).toUpperCase() + status.slice(1)}
      />
    ),
  },
  {
    title: "Category",
    dataIndex: "table",
    key: "table",
    editable: false,
    search: true,
    importIgnore: false,
    hideInTable: false,
    width: 100,
    render: (text) => (text ? text : "-"),
  },
  {
    title: "Equipment",
    key: "equipment",
    editable: false,
    search: false,
    importIgnore: false,
    hideInTable: false,
    width: 120,
    render: (_, record) => {
      if (record.description) {
        const match = record.description.match(/\[(.*?)\]/g);
        if (match && match.length >= 2) {
          const equipment = match[1].replace(/[\[\]]/g, "");
          return (
            <span>
              <i className="fa-solid fa-wrench mr-2"></i>
              {equipment}
            </span>
          );
        }
      }
      return "-";
    },
  },
  {
    title: "Date",
    dataIndex: "created_date",
    key: "created_date",
    editable: false,
    search: true,
    importIgnore: false,
    hideInTable: false,
    width: 150,
    align: 'right', // 时间列右对齐
    render: (date) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    title: "User Icon",
    dataIndex: "image",
    key: "image",
    editable: false,
    search: false,
    importIgnore: false,
    hideInTable: false,
    width: 100,
    render: (image) => (
      <Avatar
        src={image}
        size="small"
        loading="lazy"
        placeholder={
          <Avatar size="small" style={{ backgroundColor: "#f0f0f0" }}>
            <i className="fa-solid fa-user"></i>
          </Avatar>
        }
      />
    ),
  },
  {
    title: "",
    valueType: "option",
    width: "6rem",
    importIngore: true,
    render: (text, record, _, action) => (
      <div className={"space-around"}>
        <a
          key="delete"
          onClick={(e) => {
            e.stopPropagation();
            const userId = store.getState().Auth.userId;
            api
              .deleteNotification(record.id, { user_id: userId })
              .then(() => {
                if (action?.reload) {
                  action.reload();
                }
              })
              .catch((error) => {
                console.error("删除通知失败:", error);
              });
          }}
        >
          <i className="fas fa-trash text-lg"></i>
        </a>
        {/* <a
          onClick={(e) => {
            e.stopPropagation();
            return action ? renderDrawer(text, record.id) : "";
          }}
        >
          <i className="fas fa-expand-arrows-alt text-lg"></i>
        </a> */}
      </div>
    ),
  },
];

export default NotificationColumns;
